import { render, staticRenderFns } from "./CouponCreate.vue?vue&type=template&id=383e8fd8&scoped=true"
import script from "./CouponCreate.vue?vue&type=script&lang=js"
export * from "./CouponCreate.vue?vue&type=script&lang=js"
import style0 from "./CouponCreate.vue?vue&type=style&index=0&id=383e8fd8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383e8fd8",
  null
  
)

export default component.exports